// extracted by mini-css-extract-plugin
export var divider = "_gl-7";
export var itemsToggle = "_gl-8";
export var mergeModal = "_gl-1";
export var optionCard = "_gl-4";
export var radioGroup = "_gl-6";
export var radioOption = "_gl-0";
export var selected = "_gl-5";
export var shipmentOptions = "_gl-2";
export var tableOptions = "_gl-3";